import React from 'react'
import PropTypes from 'prop-types'
import { Upload } from 'antd'

import UploadQueue from './UploadQueue'
import DragDropUploadIcon from '../general/icons/DragDropUploadIcon'

import './../ui.style.scss'
// import { IMAGE_MODAL_TYPES } from 'constants/general-constants'

const Dragger = Upload.Dragger

class LocalVideoUploader extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isModalInvisible: false
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line camelcase
    if (nextProps.isLocalFolderOpen) {
      // if (!nextProps.mode === IMAGE_MODAL_TYPES.ASSET_FILE_UPLOAD_MODE) {
      //   this.uploadRef.click()
      // }
      this.setState({ isModalInvisible: true })
    }
  }

  render () {
    const { fileList, beforeUpload, onReorder, handleDelete, accept, listMediaCategories, onCategorySelect, mode } = this.props
    const uploadProps = {
      multiple: true,
      beforeUpload: beforeUpload,
      customRequest: () => { }
    }
    return (
      <div className={`upload-container`} >
        <div className={fileList.length === 0 ? 'full' : ''}>
          <Dragger
            {...uploadProps}
            accept={accept}
            listType='picture-card'>
            <DragDropUploadIcon />
            <p className='ant-upload-text' ref={(ref) => { this.uploadRef = ref }}>Click or drag file to this area to upload</p>
          </Dragger>
        </div>
        {fileList.length ? <UploadQueue uploadingFiles={fileList}
          onReorder={onReorder}
          handleDelete={handleDelete}
          listMediaCategories={listMediaCategories}
          onCategorySelect={onCategorySelect}
          mode={mode}
        /> : null}
      </div>
    )
  }
}

LocalVideoUploader.propTypes = {
  /**  */
  tagsList: PropTypes.array,
  /**  */
  selectedTags: PropTypes.array,
  /**  */
  handleTagChange: PropTypes.func,
  /** Parent component id */
  parentCompoent: PropTypes.string,
  /** Module name fo filtering tags */
  module: PropTypes.string

}

LocalVideoUploader.defaultProps = {
}

export default LocalVideoUploader
